module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "authentication"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('form', [_c('div', {
    staticClass: "form_group"
  }, [_c('p', {
    staticStyle: {
      "padding-left": "150px",
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.status))]), _vm._v(" "), _c('p', {
    staticClass: "warn"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }]
  }, [_vm._v(_vm._s(_vm.errors.first('name')))])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("姓名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.param.auditName),
      expression: "param.auditName"
    }],
    attrs: {
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": (_vm.param.auditName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "auditName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_group"
  }, [_c('p', {
    staticClass: "warn"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('idcard')),
      expression: "errors.has('idcard')"
    }]
  }, [_vm._v(_vm._s(_vm.errors.first('idcard')))])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v("身份证号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|idcard'),
      expression: "'required|idcard'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.param.auditImgCode),
      expression: "param.auditImgCode"
    }],
    attrs: {
      "type": "text",
      "maxlength": "18",
      "name": "idcard"
    },
    domProps: {
      "value": (_vm.param.auditImgCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "auditImgCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_group"
  }, [_c('p', {
    staticClass: "warn"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasImg),
      expression: "!hasImg"
    }]
  }, [_vm._v("点击上传")])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "choole"
    }
  }, [_vm._v("上传身份证正面图")]), _vm._v(" "), _c('file-upload', {
    ref: "upload",
    attrs: {
      "multiple": false,
      "post-action": _vm.options.url,
      "extensions": _vm.options.extensions
    },
    on: {
      "input-file": _vm.inputFile,
      "input-filter": _vm.inputFilter
    },
    model: {
      value: (_vm.files),
      callback: function($$v) {
        _vm.files = $$v
      },
      expression: "files"
    }
  }, [_vm._v("\n                    选择文件\n                ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$refs.upload || !_vm.$refs.upload.active),
      expression: "!$refs.upload || !$refs.upload.active"
    }],
    staticClass: "start",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$refs.upload.active = true
      }
    }
  }, [_vm._v("开始上传")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$refs.upload && _vm.$refs.upload.active),
      expression: "$refs.upload && $refs.upload.active"
    }],
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$refs.upload.active = false
      }
    }
  }, [_vm._v("停止上传")]), _vm._v(" "), _c('ul', {
    staticClass: "files"
  }, _vm._l((_vm.files), function(file) {
    return _c('li', [_vm._v(_vm._s(file.name) + "\n                          "), (file.error) ? _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("\n                              上传错误\n                          ")]) : _vm._e(), _vm._v(" "), (file.success) ? _c('span', {
      staticStyle: {
        "color": "#76D05E"
      }
    }, [_vm._v("\n                              上传成功\n                          ")]) : _vm._e()])
  }), 0), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v("单张图片大小不得超过1024k,宽高限制不超过2000px,允许上传的图片类型：jpg\\gif\\png")]), _vm._v(" "), _vm._l((_vm.files), function(file) {
    return _c('div', {
      staticClass: "thumb"
    }, [_c('img', {
      staticStyle: {
        "max-width": "700px"
      },
      attrs: {
        "src": file.blob,
        "alt": "预览图"
      }
    })])
  }), _vm._v(" "), (_vm.param.auditImgOne && !_vm.upload) ? _c('div', {
    staticClass: "thumb"
  }, [_c('img', {
    staticStyle: {
      "max-width": "700px"
    },
    attrs: {
      "src": _vm._f("imgPath")(_vm.param.auditImgOne),
      "alt": "预览图"
    }
  })]) : _vm._e()], 2)])]), _vm._v(" "), _c('button', {
    staticClass: "submit",
    attrs: {
      "type": "button",
      "disabled": !_vm.enableSubmit
    },
    on: {
      "click": _vm.validateBeforeSubmit
    }
  }, [_vm._v("提交认证")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12944b8a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/IdentityView.vue
// module id = 845
// module chunks = 1